import { FileActionButton } from "../file-action/file-action-controls";
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OrderListDataTable from './order-list-datatable';
import OrderListSearch from './order-list-search';
import orderServices from '../../services/orders/orderservice';
import {OrderModel} from '../../models/orders/order-list-model';
import { orderExport, detailExport, invoiceExport, invoiceDetailExport } from './order-list-export';
import AppLoading from '../app-loading/app-loading';

const OrderList = () => {
    const { t } = useTranslation();
    const [orderList, setOrderList] = useState<OrderModel[]>([]);
    const [loading, setLoading] = useState(false);

    function handleSearch(query: string, invoiced: string): void {
        setLoading(true);
        orderServices.getOrders(query).then((response: OrderModel[]) => {
            const sortedData = [...response].sort((a, b) => b.orderID - a.orderID);
            const filterOrders = (orders: OrderModel[], invoiced: string) => {
                return orders.filter(order => {
                    switch (invoiced) {
                        case "invoiced":
                            return order.orderInvoice.length > 0 && order.orderDetail.some(detail => detail.pendingQuantity <= 0);
                        case "notInvoiced":
                                return order.orderInvoice.length === 0;
                        case "partiallyInvoiced":
                            return order.orderInvoice.length > 0 && order.orderDetail.some(detail => detail.pendingQuantity > 0);
                        default:
                            return false;
                    }
                });
            };
            setOrderList(filterOrders(sortedData, invoiced));
            setLoading(false)
        }).catch(err=>{
            setLoading(false)
            console.error('Error fetching orders in Invoices:', err);
        })
    }

    return (
        <Suspense fallback={<AppLoading />}>
            <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
                <div className="col-12">                
                    <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
                        <h5 className="ml-1 mb-0">Invoices</h5>
                        <span>
                        <FileActionButton action="export" className="text-black border-round mr-2" onClick={e => orderExport(orderList)} icon="pi pi-file-export mr-1" text raised> Export Orders</FileActionButton>
                        <FileActionButton action="export" className="text-black border-round mr-2" onClick={e => detailExport(orderList)} icon="pi pi-file-export mr-1" text raised> Export Order Detail</FileActionButton>
                            <FileActionButton action="export" className="text-black border-round mr-2" onClick={e => invoiceExport(orderList)} icon="pi pi-file-export mr-1" text raised> Export Invoice</FileActionButton>
                            <FileActionButton action="export" className="text-black border-round" onClick={e => invoiceDetailExport(orderList)} icon="pi pi-file-export mr-1" text raised> Export Invoice Detail</FileActionButton>
                        </span>
                    </div>
                </div>
                <OrderListSearch onSearch={handleSearch} />            
                <OrderListDataTable data={orderList} />
            </div>
            {loading && <AppLoading />}
        </Suspense>
    );
};

export default OrderList;